"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@/i18n/routing";
import * as motion from "motion/react-client";
import { useLocale } from "next-intl";
const Footer = () => {
  const $ = _c(23);
  const locale = useLocale();
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0
    };
    t1 = {
      opacity: 1
    };
    t2 = {
      once: true
    };
    t3 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="section-divider" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0,
      translateX: -10
    };
    t6 = {
      opacity: 1,
      translateX: 0
    };
    t7 = {
      once: true
    };
    t8 = {
      delay: 0.2,
      duration: 0.5,
      ease: "easeOut"
    };
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <motion.div initial={t5} whileInView={t6} viewport={t7} transition={t8} className="flex flex-col items-center sm:items-start gap-1"><span>© {new Date().getFullYear()} Alain Di Fabio</span><span className="text-[10px] text-muted-foreground/50 font-mono">P.IVA 02881580597</span></motion.div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 0,
      translateX: 10
    };
    t11 = {
      opacity: 1,
      translateX: 0
    };
    t12 = {
      once: true
    };
    t13 = {
      delay: 0.3,
      duration: 0.5,
      ease: "easeOut"
    };
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Link href="https://github.com/adfdev" target="_blank" className="flex items-center gap-1.5 hover:text-foreground transition-colors"><svg viewBox="0 0 24 24" fill="currentColor" className="size-3.5"><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" /></svg>GitHub</Link>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Link href="https://www.linkedin.com/in/alaindifabio/" target="_blank" className="flex items-center gap-1.5 hover:text-foreground transition-colors"><svg viewBox="0 0 24 24" fill="currentColor" className="size-3.5"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>LinkedIn</Link>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  let t17;
  let t18;
  let t19;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Link href="https://www.x.com/adfdev/" target="_blank" className="flex items-center gap-1.5 hover:text-foreground transition-colors"><svg viewBox="0 0 24 24" fill="currentColor" className="size-3.5"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>Twitter</Link>;
    t17 = <span className="w-px h-3 bg-border" />;
    t18 = <Link href="/blog" className="hover:text-foreground transition-colors">Blog</Link>;
    t19 = <span className="w-px h-3 bg-border" />;
    $[16] = t16;
    $[17] = t17;
    $[18] = t18;
    $[19] = t19;
  } else {
    t16 = $[16];
    t17 = $[17];
    t18 = $[18];
    t19 = $[19];
  }
  const t20 = locale === "en" ? "it" : "en";
  const t21 = locale === "en" ? "Italiano" : "English";
  let t22;
  if ($[20] !== t20 || $[21] !== t21) {
    t22 = <motion.footer initial={t0} whileInView={t1} viewport={t2} transition={t3} className="relative">{t4}<div className="py-10 px-6"><div className="mx-auto max-w-6xl flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">{t9}<motion.div initial={t10} whileInView={t11} viewport={t12} transition={t13} className="flex flex-wrap justify-center items-center gap-5">{t14}{t15}{t16}{t17}{t18}{t19}<Link href="/" locale={t20} className="hover:text-foreground transition-colors">{t21}</Link></motion.div></div></div></motion.footer>;
    $[20] = t20;
    $[21] = t21;
    $[22] = t22;
  } else {
    t22 = $[22];
  }
  return t22;
};
export default Footer;